import React from "react";
import { TID } from "@/constants/tids";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Send, Loader2, Bookmark } from "lucide-react";

export default function MessageInput({ value, onChange, onSend, onSaveDraft, loading }) {
  const submit = () => {
    const text = (value || "").trim();
    if (!text || loading) return;
    onChange("");
    onSend(text);
  };

  const canSave = !!(value || "").trim();

  return (
    <div className="sticky bottom-4 mt-4">
      <div className="flex gap-2 bg-card border border-border rounded-xl p-2 shadow-sm">
        <Input
          data-testid={TID.chatInput}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && submit()}
          placeholder="Ask about your pipeline, reps, forecast, deals…"
          className="border-0 focus-visible:ring-0 shadow-none"
          disabled={loading}
        />
        <Button
          data-testid="chat-save-prompt-btn"
          variant="outline"
          onClick={() => onSaveDraft?.((value || "").trim())}
          disabled={!canSave}
          title="Save this prompt"
        >
          <Bookmark className="w-4 h-4 sm:mr-1.5" />
          <span className="hidden sm:inline">Save</span>
        </Button>
        <Button data-testid={TID.chatSendBtn} onClick={submit} disabled={loading || !canSave}>
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
        </Button>
      </div>
    </div>
  );
}
